import {
  useRef, useEffect, useCallback,
} from 'react';

const useScroll = (
  callback: any,
) => {
  const ref = useRef<HTMLDivElement>(null);
  const handleScroll = useCallback(() => {
    if (!ref || !ref.current) return;
    const { scrollTop, scrollHeight, clientHeight } = ref.current;
    const isBottom = ((scrollHeight - scrollTop - 350) < clientHeight);
    //console.log('clientHeight', clientHeight, scrollHeight - scrollTop);
    if (!isBottom) {
      return;
    }
    if (typeof callback === 'function') {
      callback();
    }
  }, [ref, callback]);

  useEffect(() => {
    // console.log('ref', ref);
    if (ref.current) {
      ref.current.addEventListener('scroll', handleScroll, true);
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('scroll', handleScroll, true);
      }
    }
  }, [ref, handleScroll]);

  return ref;
}

export default useScroll;
